<template>
    <form autocomplete="off">
        <div class="font-semibold text-lg mb-4 flex justify-between">
            {{ $t("bankDetails") }}
        </div>
        <k-input
                class="mb-4"
                id="bankName"
                label="Bank name"
                v-model="form.bankName"
                :field-errors="validation.fieldErrors"/>
        <div class="grid md:grid-cols-2 gap-3">
            <k-input
                    class="mb-4"
                    id="accountNumber"
                    label="Account number"
                    v-model="form.accountNumber"
                    :field-errors="validation.fieldErrors"/>
            <k-input
                class="mb-4"
                id="swiftCode"
                label="SWIFT code"
                v-model="form.swiftCode"
                :field-errors="validation.fieldErrors"/>
        </div>
        <k-input
            class="mb-4"
            id="accountHolderName"
            label="Account holder name"
            v-model="form.accountHolderName"
            :field-errors="validation.fieldErrors"
            :disabled="accountHolderNameProvided"
        />

        <div class="mt-6">
            <k-button @click.native.prevent="onSubmit">
                {{ $t("submit") }}
            </k-button>
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            validation: {
                type: Object,
                required: true
            },
            accountHolderName: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                form: {
                    bankName: '',
                    accountNumber: '',
                    accountHolderName: this.accountHolderName,
                    branch: '',
                    swiftCode: '',
                }
            }
        },
        computed: {
            accountHolderNameProvided() {
                return typeof this.form.accountHolderName === 'string' && this.form.accountHolderName.trim() !== ''
            }
        },
        methods: {
            async onSubmit() {
                this.$emit('submit', this.form);
            }
        }
    }
</script>

<style>

</style>

